import React from 'react';
import { createPortal } from 'react-dom';
import T from 'prop-types';
import cx from 'classnames';

import Animation from '../../../../../components/Animation';

const SlideTopModal = ({
  show,
  children,
  modalTitle,
  withPortal = true,
  className,
  onHide,
}) => {
  const modalComponent = (
    <Animation
      show={show}
      animationType="slide-fade-in-out-top"
    >
      <div className={cx('slide-top-modal', withPortal && 'with-portal', className)}>
        <div className="slide-top-modal__overlay animation-fade-element" />

        <div className="slide-top-modal__inner animation-slide-element">
          <header className="slide-top-modal__header">
            <h2 className="slide-top-modal__title">{modalTitle}</h2>
            <div className="slide-top-modal__close" onClick={() => onHide(false)}>
              <span className="hicon-close" />
            </div>
          </header>
          <section className="slide-top-modal__body">
            {children}
          </section>
        </div>
      </div>
    </Animation>
  );

  return withPortal
    ? createPortal(modalComponent, document.body)
    : modalComponent;
};

SlideTopModal.propTypes = {
  show: T.bool.isRequired,
  children: T.node.isRequired,
  modalTitle: T.string.isRequired,
  withPortal: T.bool,
  className: T.string,
  onHide: T.func.isRequired,
};

export default SlideTopModal;
